module.exports = __webpack_public_path__ + "assets/img/icon4.c846f2b7.png";